import { useEffect } from "react";
import { Heading, Resource, CTA } from "../../../components";
import { links, risk, downloads } from "./resource-data";

export default function Resources() {
  useEffect(() => {
    document.title = "Fenhuma® - Resources";
  }, []);

  return (
    <main>
      <Heading title="Resources">
        <p className="bold">
          We support you and your adult cancer patients in managing their episodes of breakthrough
          pain that are not controlled by their background opioid therapy.
        </p>
        <p>
          Utilise these resources to help patients prescribed Fenhuma® (fentanyl) to manage their
          pain.
        </p>
      </Heading>

      <section className="section section--grey section--resources">
        <div className="resource-container">
          <h2>Risk Minimisation Materials</h2>
          {risk.map((download, idx) => {
            return <Resource key={idx} data={download} type="link" />;
          })}
        </div>
      </section>

      <section className="section section--white section--resources">
        <div className="resource-container">
          <h2>Our Downloads</h2>
          {downloads.map((download, idx) => {
            return <Resource key={idx} data={download} type="download" />;
          })}
        </div>
      </section>

      <section className="section section--grey section--resources">
        <div className="resource-container">
          <h2>External Links</h2>
          {links.map((link, idx) => {
            return <Resource key={idx} data={link} type="link" />;
          })}
        </div>
      </section>

      <CTA
        heading="Still have questions about prescribing Fenhuma®?"
        copy="Contact your local Glenmark Pharmaceuticals representative"
        link="mailto:Neurology.UK@glenmarkpharma.com?subject=Fenhuma&reg; - HCP website contact"
        linkCopy="Email a representative"
        className="with-circles"
      />
    </main>
  );
}
